import styled from 'styled-components'

import Box from 'v2/components/UI/Box'

export default styled(Box).attrs({
  display: 'flex',
  width: '100%',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
})``
